export default "/images/9fdd3f9e5584871b7916e88bac0d7e75.jpg";